import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { BenefitType, CompanyTaxDistribution } from 'app/core/helpers/constants';
import { FlexibleBenefit } from 'app/core/models/flexible-benefit';
import { SubscriptionPaymentModel } from 'app/core/models/subscription-payments';
import { TaxAndFeesTooltipService } from 'app/core/service/tax-and-fees-tooltip.service';
import { CoreMediaService } from '@core/services/media.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import {TaxService} from "../../../../core/service/tax.service";
import {AuthenticationService} from "../../../../core/service";
import {AutoOrderPaymentModel} from "../../../../core/models/auto-order";

@Component({
  selector: 'app-subscription-payment-table',
  templateUrl: './subscriptions-payment-table.component.html',
  styleUrls: ['./subscriptions-payment-table.component.scss']
})
export class SubscriptionPaymentTableComponent implements OnInit, OnChanges {
  private ngUnsubscribe = new Subject<void>();
  public paymentValueTotal = 0;
  public taxesValueTotal = 0;
  public paymentTotal = 0;
  public taxDistributionEnm = CompanyTaxDistribution;
  public isMobile = false;

  @Input()
    benefitType: BenefitType;

  @Input()
    benefitTaxCategory: number;

  @Input()
    payments?: SubscriptionPaymentModel[];

  @Input()
    autoOrderPayments?: AutoOrderPaymentModel[];

  @Input()
    taxDistributionSource: CompanyTaxDistribution;

  @Input()
    monthlyBudget: number;

  taxAndFeesTooltipText: string;
  fitnessBenefit = false;
  public showTaxesForCompany: boolean;

  constructor(
    private taxAndFeesService: TaxAndFeesTooltipService,
    private coreMediaService: CoreMediaService,
    private mediaObserver: MediaObserver,
    private taxService: TaxService,
    private authenticationService: AuthenticationService,) { }

  ngOnInit(): void {
    this.payments.forEach((payment: SubscriptionPaymentModel) => {
      this.paymentValueTotal += payment.paymentAmount;
      this.taxesValueTotal += payment.taxesValue;
      this.paymentTotal += payment.paymentTotal;
    });
    this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip({
        benefitTaxCategory: this.benefitTaxCategory,
        benefitTypeId: this.benefitType
      }, false);
    this.fitnessBenefit = this.benefitType === BenefitType.Fitness;
    this.subscribeToScreenChanges();
    const companyId = this.authenticationService.currentUserValue.companyId;
    this.showTaxesForCompany = !this.taxService.hideTaxes(this.taxDistributionSource, companyId);
  }

  subscribeToScreenChanges() {
    this.coreMediaService.onMediaUpdate.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        const isSmall = this.mediaObserver.isActive('bs-lt-lg');
        this.isMobile = isSmall === true;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.paymentTotal = 0;
    this.taxesValueTotal = 0;
    this.paymentValueTotal = 0;

    if(changes.payments && !changes.payments.isFirstChange()) {
      this.payments.forEach((payment: SubscriptionPaymentModel) => {
        this.paymentValueTotal += payment.paymentAmount;
        this.taxesValueTotal += payment.taxesValue;
        this.paymentTotal += payment.paymentTotal;
      });
    }
  }
}
